module.exports = __webpack_public_path__ + "img/rose-5.9b351c8e.png";